/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type InboxNotifications_viewer$ref = any;
type ProposalsNotifications_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type TensionProcessing_organization$ref: FragmentReference;
declare export opaque type TensionProcessing_organization$fragmentType: TensionProcessing_organization$ref;
export type TensionProcessing_organization = {|
  +id: string,
  +databaseId: string,
  +governanceEnabled: boolean,
  +isAgendaItemsEnabled: boolean,
  +isApmAlphaEnabled: boolean,
  +isGoalsEnabled: boolean,
  +isHotwiredAlphaEnabled: boolean,
  +viewerCanAddProposal: boolean,
  +onRestrictedPlan: boolean,
  +viewer: {|
    +id: string,
    +roles: {|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +__typename: string
        |}
      |}>
    |},
    +routes: {|
      +actionsPath: string,
      +agendaItemsPath: string,
      +projectsPath: string,
      +proposalsPath: string,
      +checklistsPath: string,
      +metricsPath: string,
      +goalsPath: string,
      +inboxPath: string,
      +addTensionPath: string,
      +addActionPath: string,
      +workspacePath: string,
    |},
    +$fragmentRefs: ProposalsNotifications_viewer$ref & InboxNotifications_viewer$ref,
  |},
  +$refType: TensionProcessing_organization$ref,
|};
export type TensionProcessing_organization$data = TensionProcessing_organization;
export type TensionProcessing_organization$key = {
  +$data?: TensionProcessing_organization$data,
  +$fragmentRefs: TensionProcessing_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TensionProcessing_organization",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "governanceEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAgendaItemsEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isApmAlphaEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGoalsEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isHotwiredAlphaEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanAddProposal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "onRestrictedPlan",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "RoleConnection",
          "kind": "LinkedField",
          "name": "roles",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoleEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Role",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Routes",
          "kind": "LinkedField",
          "name": "routes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actionsPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "agendaItemsPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "projectsPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "proposalsPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "checklistsPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "metricsPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "goalsPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "inboxPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "addTensionPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "addActionPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "workspacePath",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProposalsNotifications_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "InboxNotifications_viewer"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a6533315bddfb081847e24ccf5591729';

module.exports = node;
